var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2762_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8436 16.0128C18.3052 16.3459 18.4341 18.3585 19.9888 18.5634H37.7568C39.367 18.3471 39.4157 16.2452 37.8096 16L19.8436 16.0128ZM25.2746 31.4494C23.7735 31.7483 23.7792 33.6742 25.2655 33.996L37.8096 34C39.391 33.7656 39.3748 31.6939 37.8047 31.4413L25.2746 31.4487V31.4494Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 25.3016V24.6984C12.2515 24.0992 12.6452 23.7485 13.3426 23.6908H37.6539C39.4494 23.8386 39.448 26.1614 37.6539 26.3092H13.3426C12.6452 26.2521 12.2515 25.9008 12 25.3016Z",
    fill: "#005F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8436 16.0128L37.8096 16C39.4157 16.2452 39.367 18.3471 37.7568 18.5634H19.9888C18.4341 18.3585 18.3052 16.3453 19.8436 16.0128Z",
    fill: "#005F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2746 31.4494L37.8047 31.442C39.3748 31.6946 39.391 33.7656 37.8096 34.0007L25.2655 33.9966C23.7792 33.6742 23.7735 31.749 25.2746 31.4501V31.4494Z",
    fill: "#005F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2762_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.e7f89fd9281c1b6ae9ad055241e45599.svg";
export { ForwardRef as ReactComponent };